<div class="container-fluid footer">
  <div class="row">
    <div class="container col col-12">
      <footer>Fototax © 2018</footer>
    </div>
  </div>
</div>
